import ApplicationController from '@app/javascript/controllers/application_controller'
import { updateInboxEntries } from '@app/javascript/classes/inbox'

export class Controller extends ApplicationController {
  static values = { inboxId: String }

  doConnect() {}

  batchMarkIsIrrelevant() {
    updateInboxEntries(this.inboxIdValue,
      {
        entity_ids: this.entityIds(),
        is_irrelevant: true,
        is_read: true
      },
      this.toggleIrrelevantSuccess.bind(this)
    )
  }

  entityIds() {
    return this.entitySelectController().entityIds
  }

  entitySelectController() {
    return this.application.getControllerForElementAndIdentifier(
      this.entitySelectContainer(), 'entity-select'
    )
  }

  entitySelectContainer() {
    return document.querySelector('[data-controller~="entity-select"]')
  }

  toggleIrrelevantSuccess() {
    this.inboxResultItems().forEach(inboxResultItem => {
      inboxResultItem.controllers['search-v2--inbox-result-item'].toggleIrrelevantSuccess(true)
    })
  }

  inboxResultItems() {
    return this.entityIds().map(entityId => document.querySelector(`[data-search-v2--inbox-result-item-entity-id-value=${entityId}]`))
  }
}
